import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  EStoreInitialState,
  EStoreSetAgenciesList,
  EStoreSetAgencyError,
  EStoreSetAgencyInfo,
  EStoreSetAgencyLoader,
  SetEStoreColisNumberAndDescriptionAction,
  SetEStoreReceiverAction,
  SetEStoreSenderAction,
  SetEStoreSenderIsNotReceiverAction,
  SetEStoreSubmitDataSetErrorAction,
  SetEStoreSubmitDataSetLoaderAction,
  SetEStoreSubmitDataSetSuccessAction,
} from '../EStore.types';

const initialState: EStoreInitialState = {
  agency: {
    isLoading: false,
    info: null,
    error: null,
    agencies: [],
  },
  submitData: {
    isLoading: false,
    error: null,
    success: null,
  },
  form: {
    sender: {
      firstName: '',
      lastName: '',
      email: '',
      tel: '',
      address: '',
    },
    receiver: null,
    senderIsNotReceiver: false,
    toAgency: '',
    colisNumber: 0,
    description: '',
  },
  marketingAgencyId: undefined,
};

export const EStoreSlicer = createSlice({
  name: 'eStore',
  initialState,
  reducers: {
    setEStoreAgencyLoader: (state, action: PayloadAction<EStoreSetAgencyLoader>) => {
      state.agency.isLoading = action.payload.isLoading;
    },
    setEStoreAgencyError: (state, action: PayloadAction<EStoreSetAgencyError>) => {
      state.agency.error = action.payload.error;
    },
    setEStoreAgencyInfo: (state, action: PayloadAction<EStoreSetAgencyInfo>) => {
      state.agency.info = action.payload.info;
    },
    setEStoreAgenciesList: (state, action: PayloadAction<EStoreSetAgenciesList>) => {
      state.agency.agencies = action.payload.agencies;
    },
    setEStoreSender: (state, action: PayloadAction<SetEStoreSenderAction>) => {
      state.form.sender = action.payload.sender;
      state.form.toAgency = action.payload.sender.toAgency;
    },
    setResetEStoreFormData: (state) => {
      state.form = initialState.form;
    },
    setEStoreReceiver: (state, action: PayloadAction<SetEStoreReceiverAction>) => {
      state.form.receiver = action.payload.receiver;
    },
    setEStoreSenderIsNotReceiver: (state, action: PayloadAction<SetEStoreSenderIsNotReceiverAction>) => {
      state.form.senderIsNotReceiver = action.payload.senderIsNotReceiver;
    },
    setEStoreColisNumberAndDescription: (state, action: PayloadAction<SetEStoreColisNumberAndDescriptionAction>) => {
      state.form.colisNumber = action.payload.colisNumber;
      state.form.description = action.payload.description;
    },
    setEStoreSubmitDataSetLoader: (state, action: PayloadAction<SetEStoreSubmitDataSetLoaderAction>) => {
      state.submitData.isLoading = action.payload.isLoading;
    },
    setEStoreSubmitDataSetError: (state, action: PayloadAction<SetEStoreSubmitDataSetErrorAction>) => {
      state.submitData.error = action.payload.error;
    },
    setEStoreSubmitDataSetSuccess: (state, action: PayloadAction<SetEStoreSubmitDataSetSuccessAction>) => {
      state.submitData.success = action.payload.success;
    },
    setEStoreIsFromAgencyMarketing: (state, action: PayloadAction<string | undefined>) => {
      state.marketingAgencyId = action.payload;
    },
  },
});

export const {
  setEStoreAgencyError,
  setEStoreAgencyInfo,
  setEStoreSender,
  setEStoreAgencyLoader,
  setEStoreAgenciesList,
  setEStoreSenderIsNotReceiver,
  setEStoreReceiver,
  setEStoreColisNumberAndDescription,
  setEStoreSubmitDataSetLoader,
  setEStoreSubmitDataSetError,
  setEStoreSubmitDataSetSuccess,
  setResetEStoreFormData,
  setEStoreIsFromAgencyMarketing,
} = EStoreSlicer.actions;

export const EStoreReducer = EStoreSlicer.reducer;
